import { ApplicantInterviewers } from '@app/models/recruiting/applicant-interviewers.model';
import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';
import { LinkColumn } from '@app/modules/table/interfaces/link-column.interface';

export class ApplicantColumn extends Column implements LinkColumn {
    title = 'applicant-tracker.applicant';
    sortable = true;
    type: CellDisplay = CellDisplay.internalLink;

    getDisplayPropertyValue(applicantInterviewer: ApplicantInterviewers): string {
        return applicantInterviewer.applicantInterview.applicant.fullName;
    }

    getInternalLink(applicantInterviewer: ApplicantInterviewers): (string | number)[] {
        return ['/recruiting', 'applicants', applicantInterviewer.applicantInterview.applicant.id];
    }
}
